module.exports = __webpack_public_path__ + "img/electrician.4ff72399.png";